import StatusBadge from "../../components/common/StatusBadge";

const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'File Name',
        dataIndex: 'FileName',
        render: defaultRender,
    },
    {
        title: 'File No.',
        dataIndex: 'FileNum',
        render: defaultRender,
    },
    {
        title: 'Doc Name',
        dataIndex: 'original_name',
        render: defaultRender,
    },
    {
        title: 'Source',
        dataIndex: 'sign_source',
        render: (value) => (value ? <StatusBadge status={value} /> : "--"),
    },
    {
        title: 'Status',
        dataIndex: 'statusText',
        render: defaultRender,
    },
    {
        title: 'Created Date',
        dataIndex: 'created_at',
        render: defaultRender,
    },
    {
        title: 'Action',
        dataIndex: 'action',
        render: defaultRender,
    },
];

export default columns;